import { defineMessages } from 'react-intl'

const messages = {
  text: {
    id: 'app.components.got-it.text',
    defaultMessage: 'Got it',
  },
}

export default defineMessages(messages)
